/**
 * @file ErrorBoundary.js
 * @author chenbo09
 */

import React from 'react';
import {Loading} from 'acud';
import * as Sentry from '@sentry/browser';

import {DU_PREFIX} from '../../_common/constants';
import './index.less';

const CLS_PREFIX = `${DU_PREFIX}-errorboundary`;

export interface ErrorBoundaryState {
    hasError: boolean;
}

export default class ErrorBoundary extends React.Component<any, ErrorBoundaryState> {

    state = {
        hasError: false
    };

    // 当一个路由出错，界面崩溃时候，保证在切换到其他路由，其他界面能正常显示
    componentDidUpdate(prevProps: any) {
        if (prevProps.pathname !== this.props.pathname) {
            this.setState({hasError: false});
        }
    }

    // hooks好像模拟不了这个生命周期
    componentDidCatch(error: any, errorInfo: any) {
        // Display fallback UI
        this.setState({hasError: true});
        Sentry.withScope((scope: any) => {
            Object.keys(errorInfo).forEach(key => {
                scope.setExtra(key, errorInfo[key]);
            });
            Sentry.captureException(error);
        });
    }

    showSentryReportDialog = () => {
        Sentry.showReportDialog();
    };

    render() {
        const {errorPage} = this.props;

        if (this.state.hasError) {
            // You can render any custom fallback UI
            return (
                <div className={CLS_PREFIX}>
                    {
                        errorPage || (
                            <div>
                                <a onClick={this.showSentryReportDialog}>
                                    <Loading tip="出错了，请重新刷新页面或者报告管理员..." />
                                </a>
                            </div>
                        )
                    }
                </div>
            );
        }
        return this.props.children;
    }
}